export default "__VITE_ASSET__XlXyYb3E__"